import router from '@/router'
import { getQueryObject } from '@/utils'
const state = {
  pagesRoute :[]
}

const mutations = {
  // 保存所有页面路由信息
  setPagesRoute(state,pages){
    state.pagesRoute = pages
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
